module.exports = __webpack_public_path__ + "img/new-reassign-upArrow.346e9043.svg";